export enum PlaceholderEnum {
  AllFiles = 'Search in All Files',
  RecentFolders = 'Search in Recent Folders',
  StarredFiles = 'Search in Starred Files',
  DeletedFiles = 'Search in Deleted Files'
}

export enum NavigationEnum {
  AllFiles = 'all-files',
  RecentFolders = 'recent-folders',
  StarredFiles = 'starred-files',
  DeletedFiles = 'deleted-files'
}

export const CommonConstants = {
  AllFilesId: 'fb9a453d-3879-43f8-89b2-b1f15d5gr4fb',
  templateId: 'fb9a453d-3879-43f8-89b2-b1f15d5f24fb'
};

export enum ModuleRoutes {
  Warranty = 'Warranty',
  FileManager = 'File Management',
  FileManagerAdmin = 'File Management Admin',
  UserManagement = 'Administration',
  Scheduler = 'Scheduler',
  HomeBuilding = 'Home Building',
  Accounting = 'Accounting',
  Sales = 'Sales',
  Dsm = 'DSM',
  Buyer = 'Buyer Connect',
  ExecutiveConsole = 'Executive Console'
}

export enum PhoneType {
  mobile = 'phone',
  office = 'building',
  home = 'house',
  fax = 'printer'
}
export enum CraftType {
  Subcontract = 0,
  Parts = 1,
  BidRates = 2
}
export enum TitleEnum {
  Mr = 'MR',
  Mrs = 'MRS',
  Ms = 'Miss'
}
